module.exports = __webpack_public_path__ + "files/8fe44d1761f7200c21a075c372492879.png";